import React from 'react';
import * as styles from './styles.ve.css';

export const PlayCircleSolid: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 114 114"
    className={styles.iconSvgStyles}
    fill="none"
    data-track-tag="PlayCircleSolid"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      d="M56.8889 113.778C88.3078 113.778 113.778 88.3078 113.778 56.8889C113.778 25.47 88.3078 0 56.8889 0C25.47 0 0 25.47 0 56.8889C0 88.3078 25.47 113.778 56.8889 113.778Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M71.0394 54.1579C73.4938 55.6669 73.5181 58.0986 71.0394 59.6226L50.6667 72.1483C48.2123 73.6573 46.2227 72.7906 46.2227 70.1768V43.6037C46.2227 41.0059 48.188 40.1082 50.6667 41.6322L71.0394 54.1579Z"
      fill="white"
    />
  </svg>
);
